import { useAppSelector } from '@shared/hooks/useAppSelector'
import { message } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { clearGlobalErrorAction } from 'store/actions/globalError'
import styles from './GlobalError.module.scss'

function GlobalError() {
  const { message: error } = useAppSelector((state) => state.globalError)
  const dispatch = useDispatch()

  const showMessage = () => {
    message.error({
      maxCount: 2,
      duration: 5,
      content: error,
      className: styles.customMessageBox,
      onClose() {
        dispatch(clearGlobalErrorAction())
      },
    })
  }

  useEffect(() => {
    if (error) {
      showMessage()
    }
  }, [error])

  return <></>
}

export default GlobalError
